"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrganizationSchema = void 0;
const getOrganizationSchema = () => {
    return {
        name: 'Chewy',
        '@type': 'Organization',
    };
};
exports.getOrganizationSchema = getOrganizationSchema;
//# sourceMappingURL=organization-schema.js.map